/* global foodbox */
import slick from 'slick-carousel'
import {SCROLL_TEST} from './Paramaters'
import Video from './parts/Video'
import Section from './parts/Section'
import Menu from './parts/Menu'
import Advantages from './parts/Advantages'
import $ from 'jquery';
import {isRtl,isMobile ,scroll_to, isInViewport} from './Helpers';
import UserDevice from './UserDevice';
import State,{state} from './State';
import Foodbox from './Foodbox';
import Jobs from './parts/Jobs';
import AOS from 'aos';

$(() => {
    foodbox['state'] = state;
    foodbox['device'] = new UserDevice();

    AOS.init();


   /* $(window).on('scroll',  _.debounce((e)=>{
        console.log(e)
        $(document).trigger(SCROLL_TEST,e)
    }, 100));*/

    set_up_sections();
    set_up_videos();
    set_up_sliders();
    Jobs.init();


   $('.scroll_next').click((e)=>{
       e.preventDefault();
       const section = $(e.target).parents('section')
       const next = section.next('section')
       scroll_to(next.offset().top,350)
   })


    new Menu();
    //new Advantages();


    //new Foodbox({dom:'#main'}).render()

});







function set_up_sections(){
        $('section.section').each((i,e)=>{
            new Section({
                element:e
            })
        })
}

function set_up_sliders(){
    $('#advantages-media-slider').slick({
        rtl: isRtl(),
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay:  true,
        adaptiveHeight: true,
        autoplaySpeed:5000
    });
    if(foodbox.customers_show_as_slider ){
        $('#customers .items').slick({
            rtl: isRtl(),
            slidesToShow: 6,
            slidesToScroll: 3,
            arrows: false,
            dots: true,
            autoplay:  true,
            autoplaySpeed: 4000,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 780,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 350,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });
    }


    if(foodbox.features_show_as_slider ){
        $('#features .items').slick({
            rtl: isRtl(),
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            autoplay:  true,
            adaptiveHeight: true,
            autoplaySpeed:5000,
            responsive: [
                {
                    breakpoint: 780,
                    settings: {
                        arrows: false,
                        centerMode: true,
                    }
                },
            ]
        });
    }
}
function set_up_videos(){
    $('.inner-bg').each((i,e)=>{
        new Video({
            wrap:e
        })
    })
}

